import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UUID} from '@util/types';
import {Observable} from 'rxjs';
import {BusinessInitiationResource, MyBusinessRelationResult} from '@services/resource/business-initiation-resource';
import {ConfigService} from '@services/infra/config.service';
import {ExcelDownloadResponse} from '@services/resource/excel-download-response';
import {ProductQuery} from '@services/resource/search-product-resources';

@Injectable({
  providedIn: 'root',
})
export class BusinessInitiationService {
  constructor(
    private readonly conf: ConfigService,
    private readonly http: HttpClient,
  ) {}

  public setStatus(companyId: UUID, startupId: UUID, res: BusinessInitiationResource): Observable<MyBusinessRelationResult> {
    const url = `${this.conf.backendUrl}/v1/initiation/${companyId}/${startupId}`;
    return this.http.put<MyBusinessRelationResult>(url, res);
  }

  public getStatus(companyId: UUID, startupId: UUID): Observable<MyBusinessRelationResult> {
    const url = `${this.conf.backendUrl}/v1/initiation/${companyId}/${startupId}`;
    return this.http.get<MyBusinessRelationResult>(url);
  }

  public generateExport(query: ProductQuery): Observable<ExcelDownloadResponse> {
    const requestUrl = `${this.conf.backendUrl}/v1/reports/business-relations`;
    return this.http.post<ExcelDownloadResponse>(requestUrl, query);
  }
}
